import { css } from 'theme-ui';
import styled from '../../lib/transient-styled';
import pxToRem from '../../utils/pixelsToRem';

export const ParentSubCategory = styled.h2(
  css({
    position: 'relative',
    fontSize: pxToRem(14),
    lineHeight: pxToRem(28),
    letterSpacing: '0.05em',
    textTransform: 'capitalize',
    mb: '8px',
    borderColor: 'secondaryGreen',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '&:hover': {
      borderColor: 'hoverLink',
    },
  }),
  ({ $isActive, $isDisabled }) =>
    css({
      pl: $isActive ? '18px' : '4px',
      ml: $isActive && '-18px',
      borderLeft: $isActive && '4px solid',
      color: $isActive ? 'greenDark' : 'text',
      fontWeight: $isActive ? '600' : '400',
      cursor: $isDisabled ? 'default' : 'pointer',

      '&:hover': {
        color: $isDisabled ? 'text' : 'hoverLink',
      },
    }),
);

export const ChildSubCategory = styled(ParentSubCategory)(({ $isActive }) =>
  css({
    maxWidth: '180px',
    pl: $isActive ? '18px' : '23px',
    m: '0',
  }),
);
